import React, { Component } from 'react';
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from 'react-google-maps';
import ClubInfoWindow from './ClubInfoWindow';

/*
 * This is the modify version of:
 * https://developers.google.com/maps/documentation/javascript/examples/event-arguments
 *
 * Add <script src="https://maps.googleapis.com/maps/api/js"></script> to your HTML to provide google.maps reference
 */
const GoogleClubMap = withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={parseInt(props.zoom, 10)}
    defaultCenter={props.center}
    onClick={props.onMapClick}
  >
    {props.markers.map(marker => (
      <Marker {...marker} onClick={() => props.onMarkerClick(marker)}>
        {marker.showInfo && (
          <InfoWindow onCloseClick={() => props.onMarkerClose(marker)}>
            <ClubInfoWindow club={marker.club} />
          </InfoWindow>
        )}
      </Marker>
    ))}
  </GoogleMap>
));

export default class ClubMap extends Component {
  handleMapLoad = this.handleMapLoad.bind(this);
  handleMapClick = this.handleMapClick.bind(this);

  handleMapLoad(map) {
    this._mapComponent = map;
    if (map) {
      // console.log(map.getZoom());
    }
  }

  /*
   * This is called when you click on the map.
   * Go and try click now.
   */
  handleMapClick(event) {
    // TODO: handle clicks
  }

  render() {
    const center = this.props.markers[0].position;

    return (
      <GoogleClubMap
        containerElement={<div className="club-map" />}
        mapElement={<div style={{ height: `100%` }} />}
        onMapLoad={this.handleMapLoad}
        onMapClick={this.handleMapClick}
        markers={this.props.markers}
        center={center}
        zoom={this.props.zoom}
        onMarkerClick={this.props.onMarkerClick}
        onMarkerClose={this.props.onMarkerClose}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maps/ClubMap.js